import { render, staticRenderFns } from "./PluginChat.vue?vue&type=template&id=bc1e3166&scoped=true"
import script from "./PluginChat.vue?vue&type=script&lang=js"
export * from "./PluginChat.vue?vue&type=script&lang=js"
import style0 from "./PluginChat.vue?vue&type=style&index=0&id=bc1e3166&prod&lang=scss&scoped=true"
import style1 from "./PluginChat.vue?vue&type=style&index=1&id=bc1e3166&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1e3166",
  null
  
)

export default component.exports